export default function safeExecute<T, DV = null>(mapFunction: () => T, defaultValue?: DV): T | DV {
  try {
    return mapFunction();
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return defaultValue as DV;
}
